module.exports = __webpack_public_path__ + "img/fauteuil-17.3d75b31d.jpg";